import React, { useEffect, useState, useRef, useCallback } from "react";
import MainLayout from "../../Layout/mainLayout";
import './notification.css';
import { useDispatch, useSelector } from "react-redux";
import { sendNotification, getUserData, scheduleNotification } from "../../Redux/Actions/notificationActions";
import { getProjectList } from "../../Redux/Actions/projectActions";
import { getEnums } from "../../Redux/Actions/enumsActions";
import { getEventList } from "../../Redux/Actions/eventActions";
import { getNewsList } from "../../Redux/Actions/newsAction";
import { viewBuilderList } from "../../Redux/Actions/builderActions";
import { listRewardVouchers } from "../../Redux/Actions/rewardsAction";
import SelectInput from "../../Global Functions/selectInput";
import { viewCountryListPagination, viewCityListPagination, viewStateListPagination } from "../../Redux/Actions/settingsActions";
import toast from "react-hot-toast";
import ImageShowerModalGlobal from "../../Global Functions/imageShowerModalGlobal";
import { AddImageAll } from "../../Global Functions/addImage";
import TextInput from "../../Global Functions/textInput";

const ConfirmationModal = ({ message, onConfirm, onCancel }) => (
    <div className="modal-overlay">
        <div className="modal-content-copy">
            <p>{message}</p>
            <div className="modal-buttons">
                <button onClick={onConfirm} className="modal-yes-button">Yes</button>
                <button onClick={onCancel} className="modal-no-button">No</button>
            </div>
        </div>
    </div>
);

const ScheduleModal = ({ onClose, onSchedule }) => {
    const [date, setDate] = useState("");
    const [time, setTime] = useState("");

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!date || !time) {
            alert("Please select both date and time");
            return;
        }
        onSchedule({ date, time });
        onClose();
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content-copy">
                <h3>Schedule Notification</h3>
                <form onSubmit={handleSubmit}>
                    <label>
                        Select Date:
                        <input
                            type="date"
                            value={date}
                            min={new Date().toISOString().split('T')[0]}
                            onChange={e => setDate(e.target.value)}
                            required
                        />
                    </label>
                    <br />
                    <label>
                        Select Time:
                        <input
                            type="time"
                            value={time}
                            onChange={e => setTime(e.target.value)}
                            required
                        />
                    </label>
                    <br />
                    <button type="submit" className="modal-yes-button">Schedule</button>
                    <button type="button" onClick={onClose} className="modal-no-button">Cancel</button>
                </form>
            </div>
        </div>
    );
};

const Notification = () => {
    const dispatch = useDispatch();

    // Existing states
    const [type, setType] = useState("");
    const [title, setTitle] = useState("");
    const [message, setMessage] = useState("");
    const [recipient, setRecipient] = useState("");
    const [country, setCountry] = useState('');
    const [state, setState] = useState('');
    const [city, setCity] = useState("");
    const [imgResponseUrl, setImgResponseUrl] = useState("");
    // const [page, setPage] = useState(1);
    const fileInputRef = useRef(null);
    const [showConfirm, setShowConfirm] = useState(false);
    const [sendPayload, setSendPayload] = useState(null);
    const [isSending, setIsSending] = useState(false);
    const [showScheduleModal, setShowScheduleModal] = useState(false);
    const [scheduleDateTime, setScheduleDateTime] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");
    const [selectedUsers, setSelectedUsers] = useState([]);

    const [allUsers, setAllUsers] = useState([]);
    const [userPage, setUserPage] = useState(1);
    const [hasMoreUsers, setHasMoreUsers] = useState(true);

    // FIXED: Separate states for notification type and specific entity
    const [notificationCategory, setNotificationCategory] = useState("");
    const [notificationEntityId, setNotificationEntityId] = useState("");

    // States to store full selected entity data
    const [selectedProject, setSelectedProject] = useState(null);
    const [selectedEvent, setSelectedEvent] = useState(null);
    const [selectedNews, setSelectedNews] = useState(null);
    const [selectedReward, setSelectedReward] = useState(null);
    const [selectedBuilder, setSelectedBuilder] = useState(null);


    const [projectStatus, setProjectStatus] = useState([]);
    const [projectTypeFilter, setProjectTypeFilter] = useState("");
    const [enumsProjects, setEnumsProjects] = useState([]);
    const [projectPage, setProjectPage] = useState(1);
    const [projectLimit] = useState(1150);

    const { projects, loading: projectLoading } = useSelector((state) => state.projects);
    const { events, loading: eventLoading } = useSelector((state) => state.events || {});
    const { builders, loading: builderLoading } = useSelector((state) => state.builders);
    const { news, loading: newsLoading } = useSelector((state) => state.news || {});
    const { vouchers = {}, loading: rewardLoading } = useSelector((state) => state.rewards || {});
    const rewardsData = Array.isArray(vouchers?.data) ? vouchers.data : [];
    const { enumsData } = useSelector((state) => state.enumsData);
    const { userData } = useSelector((state) => state.notification || {});
    const { countryList } = useSelector((state) => state.country || {});
    const { states } = useSelector((state) => state.states || {});
    const { cities } = useSelector((state) => state.city || {});

    const loading = userData?.loading;


    const countryData = countryList?.data;
    const stateData = states?.data;
    const cityData = cities?.data;

    // Fetch project enums and countries
    useEffect(() => {
        dispatch(getEnums());
        dispatch(viewCountryListPagination());
        dispatch(getEventList({ page: 1, limit: 1000, is_deleted: false }));
        dispatch(getNewsList({ page: 1, limit: 1000, is_deleted: false }));
        dispatch(listRewardVouchers({ page: 1, limit: 1000, is_deleted: false }));
        dispatch(viewBuilderList({ page: 1, limit: 1000, is_deleted: false }));
    }, [dispatch]);

    // Set project status enums
    useEffect(() => {
        if (enumsData?.data?.ProjectStatus) {
            const statusEnums = Object.values(enumsData.data.ProjectStatus).filter(
                (s) => s !== "declined"
            );
            if (statusEnums.length > 0) {
                setEnumsProjects(statusEnums);
                setProjectStatus(statusEnums);
            }
        }
    }, [enumsData]);

    const fetchProjects = useCallback(() => {
        if (enumsProjects.length === 0) return;

        const filteredStatus = enumsProjects.filter((s) => s !== "declined");
        const projectData = {
            page: projectPage,
            limit: projectLimit,
            status: filteredStatus,
            is_deleted: false,
            ...(projectTypeFilter &&
                !["published", "unpublished"].includes(projectTypeFilter) &&
                { name_withoutspace: projectTypeFilter }
            ),
            ...(projectTypeFilter && !['residential', 'commercial'].includes(projectTypeFilter) &&
                { status: projectTypeFilter }
            ),
        };

        dispatch(getProjectList(projectData));
    }, [dispatch, enumsProjects, projectPage, projectLimit, projectTypeFilter]);

    useEffect(() => {
        fetchProjects();
    }, [fetchProjects]);

    const fetchUsers = useCallback(() => {
        if (!type || !country || loading) return;
        dispatch(getUserData({
            list_for: type,
            is_deleted: false,
            page: 1,
            limit: 5000,
            country_id: country,
            state_id: state,
            city_id: city,
            filter: searchTerm
        }));
    }, [dispatch, type, country, state, city, searchTerm, loading]);

    // useEffect(() => {
    //     fetchUsers();
    // }, [fetchUsers]);

    useEffect(() => {
        setAllUsers([]);
        setUserPage(1);
        setHasMoreUsers(true);
    }, []);

    useEffect(() => {
        if (type && country && recipient === 'selected') {
            setAllUsers([]);
            setUserPage(1);
            setHasMoreUsers(true);
            fetchUsers();
        }
    }, [type, country, recipient, fetchUsers]);

    useEffect(() => {
        if (userData?.data?.length > 0) {
            setAllUsers((prevUsers) => {
                const existingUids = new Set(prevUsers.map((u) => u.uid));
                const newUsers = userData.data
                    .filter((user) => !existingUids.has(user.id))
                    .map((user) => ({
                        name: user?.name,
                        uid: user?._id,
                        uids: user?.id,
                    }));

                return [...prevUsers, ...newUsers];
            });

            if (userPage === 1) setHasMoreUsers(true);
        } else if (userData?.data?.length === 0 && userPage > 1) {
            setHasMoreUsers(false);
        }
    }, [userData, userPage]);


    // Country/State/City cascading
    useEffect(() => {
        if (country) {
            dispatch(viewStateListPagination({ country: country }));
        }
        if (state) {
            dispatch(
                viewCityListPagination({
                    state: state,
                    country: country,
                })
            );
        }
    }, [dispatch, country, state]);

    // const users = Array.isArray(userData?.data)
    //     ? userData.data.map((user) => ({
    //         name: user?.name,
    //         uid: user?.id,
    //         id: user?.id
    //     }))
    //     : [];

    // const filteredUsers = users?.filter((user) => {
    //     const name = (user.name || "").toLowerCase();
    //     const uid = (user.uid || "").toLowerCase();
    //     const term = searchTerm.toLowerCase();
    //     return name.includes(term) || uid.includes(term);
    // });

    const options = ["user", "consultant", "builder"];

    const handleRecipientChange = (value) => {
        setRecipient(prev => (prev === value ? '' : value));
    };

    const handleUserCheck = (userId) => {
        setSelectedUsers(prev =>
            prev.includes(userId)
                ? prev.filter(i => i !== userId)
                : [...prev, userId]
        );
    };

    // const handleScroll = (e) => {
    //     const { scrollTop, scrollHeight, clientHeight } = e.target;
    //     if (scrollTop + clientHeight >= scrollHeight - 5) {
    //         setPage(prev => prev + 1);
    //     }
    // };

    const handleScroll = (e) => {
        const { scrollTop, scrollHeight, clientHeight } = e.target;
        if (scrollTop + clientHeight >= scrollHeight - 5 && hasMoreUsers && !loading) {
            setUserPage(prev => prev + 1);
        }
    };

    const combineToUTCISO = (date, time) => {
        const localDateTime = new Date(`${date}T${time}:00`);
        return localDateTime.toISOString();
    };

    const handleRemoveImage = () => {
        setImgResponseUrl("");
        if (fileInputRef.current) {
            fileInputRef.current.value = "";
        }
    };

    // Reset filters when type changes
    const handleTypeChange = (e) => {
        const newType = e.target.value;
        setType(newType);
        setProjectStatus([]);
        setProjectTypeFilter("");
        setNotificationCategory("");
        setNotificationEntityId("");
        setSelectedProject(null);
        setSelectedEvent(null);
        setSelectedNews(null);
        setSelectedReward(null);
        setProjectPage(1);
        setState("");
        setCity("");
    };

    const openScheduleModal = () => {
        setShowScheduleModal(true);
    };

    const getTypeData = () => {

        if (notificationCategory === 'project' && selectedProject) {
            return {
                images: selectedProject.images?.map(img => img.url) || [],
                cover_photo: selectedProject.cover_photo,
                cover_photo_thumbnail: selectedProject.cover_photo_thumbnail,
                project_id: selectedProject.project_id,
                project_name: selectedProject.project_name,
                brand_name: selectedProject.brand_name,
                construction_status: selectedProject.construction_status
            };
        }

        if (notificationCategory === 'events' && selectedEvent) {
            return {
                images: selectedEvent.cover_photo ? [selectedEvent.cover_photo] : [],
                cover_photo: selectedEvent.cover_photo,
                event_id: selectedEvent.event_id,
                event_name: selectedEvent.event_name,
                event_name_withoutspace: selectedEvent.event_name_withoutspace,
                organizer_id: selectedEvent.organizer_id,
                is_free: selectedEvent.is_free,
                is_remind_before: selectedEvent.is_remind_before,
                start_date: selectedEvent.start_date,
                start_time: selectedEvent.start_time,
                start_date_utc: selectedEvent.start_date_utc,
                end_date: selectedEvent.end_date,
                end_date_utc: selectedEvent.end_date_utc,
                end_time: selectedEvent.end_time,
                no_of_audience: selectedEvent.no_of_audience,
                about_event: selectedEvent.about_event,
                status: selectedEvent.status,
                location: selectedEvent.location
            };
        }

        if (notificationCategory === 'news' && selectedNews) {
            return {
                images: selectedNews.image ? [selectedNews.image] : [],
                news_id: selectedNews.news_id,
                title: selectedNews.title,
                start_date: selectedNews.start_date,
                end_date: selectedNews.end_date,
                description: selectedNews.description,
                status: selectedNews.status,
                news_link: selectedNews.news_link,
                category: selectedNews.category,
                url: selectedNews.url,
            };
        }

        if (notificationCategory === 'rewards' && selectedReward) {
            return {
                images: selectedReward.image ? [selectedReward.image] : [],
                cover_photo: selectedReward.image,
                voucher: selectedReward.voucher,
                title: selectedReward.title,
                description: selectedReward.description,
                reward_points: selectedReward.reward_points,
                brochure: selectedReward.brochure,
                position: selectedReward.position,
                primary: selectedReward.primary,
                terms_and_conditions: selectedReward.terms_and_conditions,
                reward_for: selectedReward.reward_for,
                how_to_redeem: selectedReward.how_to_redeem,
                category: selectedReward.category,
                status: selectedReward.status,
                country: selectedReward.country
            };
        }

        if (notificationCategory === 'builder' && selectedBuilder) {
            return {
                images: selectedBuilder.brand_logo ? [selectedBuilder.brand_logo] : [],
                cover_photo: selectedBuilder.brand_logo || selectedBuilder.profile_image,
                builder_id: selectedBuilder.builder_id,
                brand_name: selectedBuilder.brand_name,
                organization_name: selectedBuilder.organization_name,
                primary_contact_number: selectedBuilder.primary_contact_number,
                primary_country_code: selectedBuilder.primary_country_code,
                primary_email: selectedBuilder.primary_email,
                rera_id: selectedBuilder.rera_id,
                profile_image: selectedBuilder.profile_image,
                role: selectedBuilder.role,
                account_status: selectedBuilder.account_status,
                total_projects: selectedBuilder.total_projects,
                live_projects: selectedBuilder.live_projects
            };
        }

        return {
            images: [],
            cover_photo: '',
            cover_photo_thumbnail: ''
        };
    };



    const prepareAndShowConfirm = (e) => {
        e.preventDefault();

        let payload = {
            title: title,
            message: message,
            type_name: notificationCategory,
            // type_id: notificationEntityId,
            type_id: notificationCategory === 'none' ? 'a1b2c3d4e5f678901234abcd' : notificationEntityId,
            type_data: getTypeData(),
            ...(scheduleDateTime ? { schedule_at: combineToUTCISO(scheduleDateTime.date, scheduleDateTime.time) } : {})
        };

        if (recipient === "selected") {
            payload.notification_for = type || "";
            payload.list = selectedUsers;
            payload.type = "selected";
        } else if (recipient === "all") {
            payload.type = "all";
            payload.notification_for = type || "";
            payload.list = [];
        }

        if (imgResponseUrl) {
            payload.image = imgResponseUrl;
        }

        setSendPayload(payload);
        setShowConfirm(true);
    };

    const handleConfirmYes = async () => {
        setShowConfirm(false);
        if (!sendPayload) return;

        let res;
        res = await dispatch(sendNotification(sendPayload));
        setIsSending(false);

        if (res.success === true) {
            toast.success("Notification sent");
            // Reset all form fields
            setType("");
            setProjectStatus([]);
            setProjectTypeFilter("");
            setNotificationCategory("");
            setNotificationEntityId("");
            setSelectedProject(null);
            setSelectedEvent(null);
            setSelectedNews(null);
            setSelectedReward(null);
            setProjectPage(1);
            setState("");
            setCountry("");
            setCity("");
            setTitle("");
            setMessage("");
            setRecipient("");
            setImgResponseUrl("");
            setSelectedUsers([]);
            setSearchTerm("");
            setAllUsers([]);
            setUserPage(1);
            setHasMoreUsers(true);
            setSendPayload(null);
            setScheduleDateTime(null);
            // setPage(1);
        } else {
            toast.error("Error sending notification");
        }
    };

    const handleScheduleConfirm = async (datetime) => {
        setShowScheduleModal(false);
        const scheduleAt = combineToUTCISO(datetime.date, datetime.time);

        let payload = {
            title,
            message,
            type_name: notificationCategory,
            type_id: notificationEntityId,
            type_data: getTypeData(),
            schedule_at: scheduleAt,
        };

        if (recipient === "selected") {
            payload.notification_for = type || "";
            payload.list = selectedUsers;
            payload.type = "selected";
        } else if (recipient === "all") {
            payload.type = "all";
            payload.notification_for = type || "";
            delete payload.list;
        }

        if (imgResponseUrl) {
            payload.image = imgResponseUrl;
        }

        setIsSending(true);
        const res = await dispatch(scheduleNotification(payload));
        setIsSending(false);

        if (res.success) {
            toast.success(`Notification scheduled for ${datetime.date} at ${datetime.time}`);
            // Reset all form fields
            setType("");
            setProjectStatus([]);
            setProjectTypeFilter("");
            setNotificationCategory("");
            setNotificationEntityId("");
            setSelectedProject(null);
            setSelectedEvent(null);
            setSelectedNews(null);
            setSelectedReward(null);
            setProjectPage(1);
            setState("");
            setCountry("");
            setCity("");
            setTitle("");
            setMessage("");
            setRecipient("");
            setImgResponseUrl("");
            setSelectedUsers([]);
            setSearchTerm("");
            setAllUsers([]);
            setUserPage(1);
            setHasMoreUsers(true);
            setSendPayload(null);
            setScheduleDateTime(null);
            // setPage(1);
        } else {
            toast.error("Error scheduling notification");
        }
    };

    const handleConfirmNo = () => {
        setShowConfirm(false);
        setSendPayload(null);
    };

    const isFormValid = () => {
        if (type === 'none') return true;
        if (!type) return false;
        if (!country) return false;
        if (notificationCategory === 'none') return true;
        if (!notificationCategory) return false;
        if (!notificationEntityId) return false;
        if ((type === "builder" || type === "consultant") && (!state || !city)) return false;
        if (!title || title.trim() === "") return false;
        if (!message || message.trim() === "") return false;
        if (!recipient) return false;
        if (recipient === "selected" && selectedUsers.length === 0) return false;
        return true;
    };

    const notificationCategories = [
        { label: "none", value: "none" },
        { label: "Project", value: "project" },
        { label: "Rewards", value: "rewards" },
        { label: "Builder", value: "builder" },
        { label: "News", value: "news" },
        { label: "Events", value: "events" }
    ];

    return (
        <div>
            <MainLayout>
                <div className="notification-outlet">
                    <div className="notification-header">
                        <div className="notification-heading">
                            <h2>Notification</h2>
                            <div>
                                <button
                                    onClick={(e) => prepareAndShowConfirm(e)}
                                    className="notification-send-button"
                                    disabled={!isFormValid() || isSending}
                                >
                                    {isSending ? "Sending..." : "Send"}
                                </button>
                                <button
                                    className="notification-send-button"
                                    onClick={openScheduleModal}
                                    style={{ marginLeft: "10px" }}
                                    disabled={!isFormValid()}
                                >
                                    Schedule
                                </button>
                            </div>
                        </div>
                        <span>Create a notification to send to your users</span>
                    </div>
                    <div className="notification-body">
                        <div className="notification-body-left">
                            <div className="form-group custom-select">
                                <SelectInput
                                    required
                                    name="type"
                                    value={type}
                                    placeholder="Select an option"
                                    label={<span>Type<span style={{ color: "red" }}>*</span></span>}
                                    options={options.map((option) => ({ label: option, value: option }))}
                                    onChange={handleTypeChange}
                                />
                            </div>

                            {/* Country Select */}
                            <div className="form-group custom-select">
                                <SelectInput
                                    required
                                    name="country"
                                    value={country}
                                    placeholder="Select an option"
                                    label={<span>Country<span style={{ color: "red" }}>*</span></span>}
                                    options={
                                        countryData?.map((country) => ({
                                            label: country.country_name,
                                            value: country._id
                                        })) || []
                                    }
                                    onChange={(e) => setCountry(e.target.value)}
                                />
                            </div>

                            <div className="form-group custom-select">
                                <SelectInput
                                    required
                                    name="notificationCategory"
                                    value={notificationCategory}
                                    placeholder="Select notification type"
                                    label={<span>Notification Type<span style={{ color: "red" }}>*</span></span>}
                                    options={notificationCategories}
                                    onChange={(e) => {
                                        setNotificationCategory(e.target.value);
                                        setNotificationEntityId("");
                                        setSelectedProject(null);
                                        setSelectedEvent(null);
                                        setSelectedNews(null);
                                        setSelectedBuilder(null);
                                        setSelectedReward(null);
                                    }}
                                />
                            </div>

                            {/* Project Select */}
                            {notificationCategory === "project" && (
                                <div className="form-group custom-select">
                                    <SelectInput
                                        required={notificationCategory === "project"}
                                        name="projectId"
                                        value={notificationEntityId}
                                        placeholder="Select a project"
                                        label={<span>Project<span style={{ color: "red" }}>*</span></span>}
                                        options={
                                            projects?.data?.map((project) => ({
                                                label: project.project_name || project.name,
                                                value: project._id
                                            })) || []
                                        }
                                        onChange={(e) => {
                                            const selectedProjectData = projects?.data?.find(p => p._id === e.target.value);
                                            setNotificationEntityId(e.target.value);
                                            setSelectedProject(selectedProjectData || null);
                                        }}
                                        disabled={projectLoading || !projects?.data?.length}
                                    />
                                </div>
                            )}

                            {notificationCategory === "events" && (
                                <div className="form-group custom-select">
                                    <SelectInput
                                        required={notificationCategory === "events"}
                                        name="eventId"
                                        value={notificationEntityId}
                                        placeholder="Select an event"
                                        label={<span>Event<span style={{ color: "red" }}>*</span></span>}
                                        options={
                                            events?.data?.map((event) => ({
                                                label: event.event_name,
                                                value: event._id
                                            })) || []
                                        }
                                        onChange={(e) => {
                                            const selectedEventData = events?.data?.find(ev => ev._id === e.target.value);
                                            setNotificationEntityId(e.target.value);
                                            setSelectedEvent(selectedEventData || null);
                                        }}
                                        disabled={eventLoading || !events?.data?.length}
                                    />
                                </div>
                            )}


                            {/* News Select */}
                            {notificationCategory === "news" && (
                                <div className="form-group custom-select">
                                    <SelectInput
                                        required={notificationCategory === "news"}
                                        name="newsId"
                                        value={notificationEntityId}
                                        placeholder="Select news"
                                        label={<span>News<span style={{ color: "red" }}>*</span></span>}
                                        options={
                                            news?.data?.map((newsItem) => ({
                                                label: newsItem.title || newsItem.name,
                                                value: newsItem._id
                                            })) || []
                                        }
                                        onChange={(e) => {
                                            const selectedNewsData = news?.data?.find(n => n._id === e.target.value);
                                            setNotificationEntityId(e.target.value);
                                            setSelectedNews(selectedNewsData || null);
                                        }}
                                        disabled={newsLoading || !news?.data?.length}
                                    />
                                </div>
                            )}

                            {/* Builder Select */}
                            {notificationCategory === "builder" && (
                                <div className="form-group custom-select">
                                    <SelectInput
                                        required={notificationCategory === "builder"}
                                        name="builderId"
                                        value={notificationEntityId}
                                        placeholder="Select a builder"
                                        label={<span>Builder<span style={{ color: "red" }}>*</span></span>}
                                        options={
                                            builders?.data?.map((builder) => ({
                                                label: builder.brand_name || builder.name || builder.title,
                                                value: builder._id
                                            })) || []
                                        }
                                        onChange={(e) => {
                                            const selectedBuilderData = builders?.data?.find(b => b._id === e.target.value);
                                            setNotificationEntityId(e.target.value);
                                            setSelectedBuilder(selectedBuilderData || null);
                                        }}
                                        disabled={builderLoading || !builders?.data?.length}
                                    />
                                </div>
                            )}


                            {/* Rewards Select */}
                            {notificationCategory === "rewards" && (
                                <div className="form-group custom-select">
                                    <SelectInput
                                        required={notificationCategory === "rewards"}
                                        name="rewardId"
                                        value={notificationEntityId}
                                        placeholder="Select a reward"
                                        label={<span>Reward<span style={{ color: "red" }}>*</span></span>}
                                        options={
                                            rewardsData.map((reward) => ({
                                                label: reward.title,
                                                value: reward._id,
                                            }))
                                        }
                                        onChange={(e) => {
                                            const selectedRewardData = rewardsData.find(r => r._id === e.target.value);
                                            setNotificationEntityId(e.target.value);
                                            setSelectedReward(selectedRewardData || null);
                                        }}
                                        disabled={rewardLoading || rewardsData.length === 0}
                                    />
                                </div>
                            )}

                            {(type === "builder" || type === "consultant") && (
                                <>
                                    <div className="form-group custom-select">
                                        <SelectInput
                                            disabled={!country}
                                            required
                                            name="State"
                                            value={state}
                                            placeholder="Select An Option"
                                            label="State"
                                            options={
                                                stateData?.map((state) => ({
                                                    label: state.state_name,
                                                    value: state._id
                                                })) || []
                                            }
                                            onChange={(e) => setState(e.target.value)}
                                        />
                                    </div>
                                    <div className="form-group custom-select">
                                        <SelectInput
                                            disabled={!state}
                                            required
                                            name="City"
                                            value={city}
                                            placeholder="Select An Option"
                                            label="City"
                                            options={
                                                cityData?.map((city) => ({
                                                    label: city.city_name,
                                                    value: city._id
                                                })) || []
                                            }
                                            onChange={(e) => setCity(e.target.value)}
                                        />
                                    </div>
                                </>
                            )}

                            <hr />
                            <h2>Notification Details</h2>
                            <div className="form-group">
                                <label>Notification Title<span style={{ color: "red" }}>* </span><span>(Max 50 characters)</span></label>
                                <input
                                    className="notification-title"
                                    style={{ width: "102%", }}
                                    type="text"
                                    placeholder="Enter Title"
                                    maxLength={50}
                                    value={title}
                                    onChange={(e) => setTitle(e.target.value.trimStart())}
                                />
                            </div>
                            <div className="form-group">
                                <label>Notification Message<span style={{ color: "red" }}>* </span><span>(Max 150 characters)</span></label>
                                <textarea
                                    rows="4"
                                    placeholder="Enter message"
                                    maxLength={150}
                                    value={message}
                                    onChange={(e) => setMessage(e.target.value)}
                                    style={{
                                        resize: "none",
                                        width: "103%",
                                        height: "100px"
                                    }}
                                />
                            </div>
                            <div>
                                <span className="span-class">
                                    Upload Notification Image<span style={{ color: "red" }}>*</span>
                                </span>
                                <input
                                    accept=".jpg,.jpeg,.png,.webp,.mp4,.avi"
                                    onChange={async (event) => {
                                        const uploadedFile = event.target.files[0];
                                        if (uploadedFile) {
                                            const allowedTypes = [
                                                "image/jpeg",
                                                "image/jpg",
                                                "image/png",
                                                "image/webp",
                                                //   "video/mp4",
                                                //   "video/x-msvideo",
                                            ];
                                            if (!allowedTypes.includes(uploadedFile.type)) {
                                                toast.error(
                                                    "Only JPG, JPEG, PNG, WebP, MP4, and AVI files are allowed!"
                                                );
                                                event.target.value = "";
                                                return;
                                            }
                                            if (uploadedFile.type.startsWith("image/")) {
                                                const img = new Image();
                                                img.onload = async () => {
                                                    const imgRatio = img.width / img.height;
                                                    if (Math.abs(imgRatio - 1.6 / 0.9) > 0.09) {  // ~16:9 tolerance
                                                        toast.error("Image must have a 16:9 aspect ratio.");
                                                        return;
                                                    }
                                                    const responseUrl = await AddImageAll(uploadedFile);  // Use your existing AddImageAll
                                                    if (responseUrl) {
                                                        setImgResponseUrl(responseUrl);
                                                    }
                                                };
                                                img.src = URL.createObjectURL(uploadedFile);
                                            } else {
                                                const responseUrl = await AddImageAll(uploadedFile);
                                                if (responseUrl) {
                                                    setImgResponseUrl(responseUrl);
                                                }
                                            }
                                        }
                                        event.target.value = "";
                                    }}
                                    id="notificationImage"
                                    hidden
                                    type="file"
                                    ref={fileInputRef}
                                    className="input-class"
                                />
                                <label className="label-class-image" htmlFor="notificationImage">
                                    Click to Upload Image<span style={{ color: "red" }}>*</span>
                                </label>
                                {/* <ImageShowerModalGlobal
                                keyField="imgResponseUrl"  
                                setState={(newState) => setImgResponseUrl(newState.imgResponseUrl || "")}
                                state={{ imgResponseUrl: imgResponseUrl }}
                                file={imgResponseUrl}
                            /> */}
                                {imgResponseUrl && (
                                    <div style={{ position: "relative", display: "inline-block", marginTop: "10px" }}>
                                        <img
                                            src={imgResponseUrl}
                                            alt="Preview"
                                            className="preview-image"
                                            style={{ width: "200px", height: "100px", objectFit: "cover" }}
                                        />
                                        <button
                                            onClick={handleRemoveImage}
                                            style={{
                                                position: "absolute",
                                                top: "5px",
                                                right: "5px",
                                                backgroundColor: "transparent",
                                                color: "red",
                                                border: "none",
                                                borderRadius: "50%",
                                                fontSize: "20px",
                                                width: "30px",
                                                height: "30px",
                                                cursor: "pointer",
                                                fontWeight: "bold",
                                                lineHeight: "1"
                                            }}
                                            aria-label="Remove image"
                                        >
                                            &times;
                                        </button>
                                    </div>
                                )}
                            </div>

                        </div>

                        <div className="notification-body-right">
                            <div>
                                <h2>Recipients</h2>
                                <span>Select who will receive this notification</span>
                            </div>
                            <hr />
                            <h4>Select Recipients <span style={{ color: "red" }}>*</span></h4>
                            <label>
                                <input
                                    type="checkbox"
                                    checked={recipient === "all"}
                                    onChange={() => handleRecipientChange("all")}
                                />
                                All Users
                            </label>
                            <br />
                            <div className="custom-selection-wrapper">
                                <label className={!type || !country ? 'disabled-label' : ''}>
                                    <input
                                        type="checkbox"
                                        checked={recipient === "selected"}
                                        onChange={() => handleRecipientChange("selected")}
                                        disabled={!type || !country}
                                    />
                                    Custom Selection
                                </label>
                                {!type || !country && (
                                    <small className="selection-hint">
                                        {!type ? 'Please select Type first' : 'Please select Country'}
                                    </small>
                                )}
                            </div>
                            {recipient === "selected" && type && country && (
                                <div className="custom-selection-notification">
                                    <div className="custom-selection-div">
                                        <label>Select Users</label>
                                        <input
                                            type="text"
                                            placeholder="Search by name or UID"
                                            value={searchTerm}
                                            onChange={(e) => {
                                                setSearchTerm(e.target.value);
                                                setAllUsers([]);
                                                setUserPage(1);
                                                // setSelectedUsers([]);
                                            }}
                                            className="user-search-input"
                                        />
                                    </div>
                                    <h4 className="notification-selection-heading">
                                        <span>Name</span>
                                        <span>UID</span>
                                    </h4>
                                    <ul
                                        onScroll={handleScroll}
                                        className="search-results"
                                        style={{ maxHeight: '300px', overflowY: 'auto' }}
                                    >
                                        {allUsers.length === 0 ? (
                                            !type ? (
                                                <li>Please select Type first</li>
                                            ) : !country ? (
                                                <li>Please select Country first</li>
                                            ) : (
                                                <li>No users found</li>
                                            )
                                        ) : (
                                            allUsers.map((user) => (
                                                <li key={user.uid} className="user-list-item">
                                                    <label className="custom-user-label">
                                                        <input
                                                            type="checkbox"
                                                            value={user.uid}
                                                            onChange={() => handleUserCheck(user.uid)}
                                                            checked={selectedUsers.includes(user.uid)}
                                                        />
                                                        <div className="user-info">
                                                            <span>{user.name}</span>
                                                            <span className="uid">{user.uids}</span>
                                                        </div>
                                                    </label>
                                                </li>
                                            ))
                                        )}
                                        {loading && <li>Loading more users...</li>}
                                    </ul>
                                </div>
                            )}
                        </div>
                    </div>

                    {showScheduleModal && (
                        <ScheduleModal
                            onClose={() => setShowScheduleModal(false)}
                            onSchedule={handleScheduleConfirm}
                        />
                    )}
                    {showConfirm && (
                        <ConfirmationModal
                            message="Are you sure you want to send this notification?"
                            onConfirm={handleConfirmYes}
                            onCancel={handleConfirmNo}
                        />
                    )}
                </div>
            </MainLayout>
        </div>
    );
};

export default Notification;
